/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';

import { CustomIcon } from '../../../components/SVGIcon';
import Localized from '../../../../shared/components/Localized';

import styles from '../../../styles';

const Wrapper = styled.div`
  padding: 1rem;
  background-color:  ${(p) => p.shaded ? styles.colors.linkWater : 'white'};
  border-radius: .25rem;
  display: flex;


  @media (max-width: 767px) {
    padding: 1.25rem;
  }
`;

const Icon = styled.div`
  padding-right: 1rem;
`;

const Label = styled.div`
  size: 12px;
`;

const MediumHeading = styled.div`
  ${styles.fonts.headingMedium}
`;

const SmallHeading = styled.div`
  ${styles.fonts.headingSmall}
`;

const Header = ({ subText, children, shaded, mainText, pageHeader }) => (
  <Wrapper shaded={ shaded }>
  { children }
    <div>
      {pageHeader && <MediumHeading>
          { mainText }
        </MediumHeading>
      }
      {!pageHeader && <SmallHeading>
          { mainText }
        </SmallHeading>
      }
      <Label>{ subText }</Label>
    </div>
  </Wrapper>
);

export default Header;
